import { render, staticRenderFns } from "./NewsView.vue?vue&type=template&id=1f351cdc&scoped=true"
import script from "./NewsView.vue?vue&type=script&lang=js"
export * from "./NewsView.vue?vue&type=script&lang=js"
import style0 from "./NewsView.vue?vue&type=style&index=0&id=1f351cdc&prod&scoped=true&lang=css"
import style1 from "./NewsView.vue?vue&type=style&index=1&id=1f351cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f351cdc",
  null
  
)

export default component.exports